import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogDescription,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
} from "@/components/ui/dialog";
import { CampaignAiActionPanel } from "./CampaignAiActionPanel";

interface CampaignAiActionDialogProps {
  campaignId: string;
  shopId: string;
  campaignName: string;
  canManageAi: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CampaignAiActionDialog({
  open,
  onOpenChange,
  campaignName,
  ...panelProps
}: CampaignAiActionDialogProps) {
  const { t } = useTranslation("smartCreation");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPopup className="h-[680px] max-w-[900px] overflow-hidden rounded-[14px]">
        <DialogHeader className="shrink-0 border-b border-line px-[22px] py-5 pr-16">
          <DialogTitle>{t("review.aiActions.title")}</DialogTitle>
          <DialogDescription className="truncate">{campaignName}</DialogDescription>
        </DialogHeader>
        <DialogPanel className="min-h-0 flex-1 px-[22px] py-4" scrollFade={false}>
          {open ? (
            <CampaignAiActionPanel
              key={`${panelProps.shopId}:${panelProps.campaignId}`}
              {...panelProps}
            />
          ) : null}
        </DialogPanel>
      </DialogPopup>
    </Dialog>
  );
}
